"use client";

import { lazy, Suspense, useEffect, useState } from "react";
import { DialogDismissalLayer } from "@/components/ui/dialog-dismissal-layer";
import {
  REPORT_ISSUE_EVENT,
  type ReportIssueEventDetail,
  isReportIssueEventDetail,
} from "@/lib/feedback/report-issue-event";
const ReportIssueDialog = lazy(() =>
  import("./report-issue-dialog").then((module) => ({ default: module.ReportIssueDialog })),
);

export function ReportIssueProvider() {
  const [open, setOpen] = useState(false);
  const [hasOpened, setHasOpened] = useState(false);
  const [context, setContext] = useState<ReportIssueEventDetail>({});

  useEffect(() => {
    function handler(event: Event) {
      if (!(event instanceof CustomEvent)) return;
      const detail: unknown = event.detail;
      setContext(isReportIssueEventDetail(detail) ? detail : {});
      setOpen(true);
      setHasOpened(true);
    }
    window.addEventListener(REPORT_ISSUE_EVENT, handler);
    document.documentElement.dataset.reportIssueReady = "";
    return () => {
      window.removeEventListener(REPORT_ISSUE_EVENT, handler);
      delete document.documentElement.dataset.reportIssueReady;
    };
  }, []);

  return hasOpened ? (
    <Suspense
      fallback={
        <DialogDismissalLayer open={open} onOpenChange={setOpen}>
          <span role="status" className="sr-only">
            Loading issue report…
          </span>
        </DialogDismissalLayer>
      }
    >
      <ReportIssueDialog
        open={open}
        onOpenChange={setOpen}
        context={context}
        triggerless
      />
    </Suspense>
  ) : null;
}
